<div mat-dialog-title>
    <div class="d-flex justify-content-between">
        <p>Create New Member</p>
        <i class="fa fa-times-circle pull-right" (click)="closeDialog()" aria-hidden="true"></i>
    </div>
</div>
<div mat-dialog-content>
    <mat-accordion>
        <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
                <mat-panel-title id="accAccountCodeMaster">
                    <div class="d-flex justify-content-between eip-pt-10 eip-pb-10">
                        <div class="title-container d-flex align-items-center" (click)="$event.stopPropagation();">
                            <mat-button-toggle-group aria-label="Font Style" class="" (change)="setMemberType($event)" [value]="selectedOption" [disabled]="isEditUser">
                                <mat-button-toggle value="ltMember">L&T Member</mat-button-toggle>
                                <mat-button-toggle value="othMember">Other Member</mat-button-toggle>
                            </mat-button-toggle-group>
                        </div>
                    </div>
                </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="eip-mt-20 eip-mb-10">
                <form [formGroup]="memForm" autocomplete="off" class="eip=pt-20">
                    <div class="row">
                        <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12" *ngIf="isInternalUser">
                            <mat-form-field style="width: 100%;">
                                <mat-label>Staff Psno</mat-label>
                                <input matInput formControlName="psNo" required>
                                <mat-error *ngIf="memForm.get('psNo').hasError('required')">
                                    Ps No is required
                                </mat-error>
                                <mat-error *ngIf="memForm.get('psNo').hasError('pattern') && !memForm.get('psNo').hasError('required')">
                                    Enter Numbers Only
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                            <mat-form-field style="width: 100%;">
                                <mat-label>ECC Web Login</mat-label>

                                <!--Code Reverted For production issue -->
                                <input matInput formControlName="webLogin" required>

                                <!--Sheriya Changes Commented for production issue-->
                                <!-- <input matInput formControlName="webLogin" required #searchInput type="text" placeholder="{{placeholder}}" [matAutocomplete]="auto" (keyup)="searchOnChange()"> -->
                                <!-- <mat-autocomplete #auto="matAutocomplete" (optionSelected)='autoCompleteChange($event.option.value)' [displayWith]="login_Name">
                              <mat-option *ngFor="let data of searchList" [value]="data">
                                  <span matTooltip="{{data.login_Name}}">{{data.login_Name}}</span>
                              </mat-option>
                          </mat-autocomplete> -->

                                <mat-error *ngIf="memForm.get('webLogin').hasError('required')">
                                    Weblogin is required
                                </mat-error>
                                <!--Sheriya Changes Commented for production issue-->
                                <!-- <div style="margin-left: 100px; margin-top: -3%; color:red;" *ngIf="this.isexistUser">
                              {{this.comment}}
                          </div> -->

                            </mat-form-field>
                        </div>
                        <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                            <mat-form-field style="width: 100%;">
                                <mat-label>Member Name</mat-label>
                                <input matInput formControlName="memName" required>
                                <mat-error *ngIf="memForm.get('memName').hasError('required')">
                                    Member name is required
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                            <mat-form-field style="width: 100%;">
                                <mat-label>Member Short Name</mat-label>
                                <input matInput formControlName="memShortName" required>
                                <mat-error *ngIf="memForm.get('memShortName').hasError('required')">
                                    Member short name is required
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                            <mat-form-field style="width: 100%;">
                                <mat-label>Email Id</mat-label>
                                <input matInput formControlName="emailId" required>
                                <mat-error *ngIf="memForm.get('emailId').hasError('required')">
                                    Email Id is required
                                </mat-error>
                                <mat-error *ngIf="!memForm.get('emailId').hasError('required') && memForm.get('emailId').hasError('email')">
                                    Please provide valid email
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12" *ngIf="!isInternalUser && !isEditUser">
                            <mat-form-field style="width: 100%;">
                                <mat-label>Password</mat-label>
                                <input matInput formControlName="password" [type]="hide?'password':'text'" required>
                                <mat-error *ngIf="memForm.get('password').hasError('required')">
                                    Password is required
                                </mat-error>
                            </mat-form-field>
                            <div class="row justify-content-left">
                                <div class="col-lg-12 mb-2">
                                    <span [ngClass]="{'badge':true, 'badge-default' : !memForm.get('password').dirty,'badge-danger' : !_is8Characters, 'badge-success' : _is8Characters }" style="margin: 1px;">8-16 Characters</span>
                                    <span [ngClass]="{'badge':true, 'badge-default' : !memForm.get('password').dirty,'badge-danger' : !_isSymbols, 'badge-success' : _isSymbols }" style="margin: 1px;">Symbols</span>
                                    <span [ngClass]="{'badge':true, 'badge-default' : !memForm.get('password').dirty,'badge-danger' : !_isComplexWord, 'badge-success' : _isComplexWord }" style="margin: 1px;">Mixed Characters</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-1 col-lg-1 col-md-2 col-sm-4 col-xs-8">
                            <mat-form-field style="width: 100%;">
                                <mat-label>Country Code</mat-label>
                                <input matInput formControlName="mobileNoPrefix">
                                <mat-error *ngIf="memForm.get('mobileNoPrefix').hasError('required')">
                                    Country code is required
                                </mat-error>
                                <mat-error *ngIf="memForm.get('mobileNoPrefix').hasError('pattern')">
                                    Country code is not valid
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                            <mat-form-field style="width: 100%;">
                                <mat-label>Mobile No</mat-label>
                                <input matInput formControlName="mobileNo">
                                <mat-error *ngIf="memForm.get('mobileNo').hasError('required')">
                                    Mobile No is required
                                </mat-error>
                                <mat-error *ngIf="memForm.get('mobileNo').hasError('pattern')">
                                    Mobile No is not valid
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                            <mat-form-field style="width: 100%;">
                                <mat-label>Designation</mat-label>
                                <input matInput formControlName="designation">
                                <mat-error *ngIf="memForm.get('designation').hasError('required')">
                                    Designation is required
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                            <edms-autocomplete [data]="businessGroups" [form]="memForm" [value]="selectedGroup" controlName="businessGroup" textField="group_Name" label="Business Group " error="Please Select Business Group"></edms-autocomplete>
                        </div>
                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12">
                            <mat-form-field style="width: 100%;">
                                <mat-label>Address</mat-label><input matInput formControlName="txtAddress">
                            </mat-form-field>
                        </div>
                        <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                            <mat-form-field floatLabel="always" appearance="none">
                                <mat-label>Status</mat-label>
                                <mat-slide-toggle color="primary" formControlName="status">
                                </mat-slide-toggle>
                                <textarea matInput hidden></textarea>
                            </mat-form-field>
                        </div>
                    </div>
                </form>
            </div>
        </mat-expansion-panel>
    </mat-accordion>
</div>
<div mat-dialog-actions>
    <div class="row justify-content-end flex-grow-1">

        <!--Code reverted for production issue-->
        <button (click)="saveMember()" class="btn btn-primary" [disabled]="!memForm.valid" type="submit" id="btnEDMSave"><i class="fa fa-save" aria-hidden="true" id="btnCopy"></i>&nbsp;{{actionButtonText}}</button>
        <button (click)="closeDialog()" class="btn btn-secondary" id="btnEDMCancel"><i class="fa fa-cancel" aria-hidden="true" id="btnCopy1"></i>&nbsp;&nbsp;Cancel</button>

        <!--Sheriya Changes Commented for production issue-->
        <!-- <button (click)="saveMember()" class="btn btn-primary" [disabled]="!memForm.valid" type="submit" id="btnEDMSave"><i class="fa fa-save" aria-hidden="true" id="btnCopy"></i>&nbsp;&nbsp;{{actionButtonText}}</button>
      <button (click)="closeDialog()" class="btn btn-secondary" id="btnEDMCancel"><i class="fa fa-cancel" aria-hidden="true" id="btnCopy1"></i>&nbsp;&nbsp;Cancel</button> -->
    </div>
</div>